/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../token/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string;
  payload: any;

  constructor(private router: Router, private tokenService: TokenService) {}

  loginSuccess(token: string) {
    this.tokenService.setToken(token);
    localStorage.setItem('logged', 'true');
    this.router.navigate(['/pages/dashboard']);

    if (this.tokenService.isSeller()) {
      if (this.tokenService.getCanSale()) {
        this.router.navigate(['/pages/punto-de-venta/ventas']);
      } else {
        this.router.navigate(['/pages/punto-de-venta/caja-registradora']);
      }
    } else {
      this.router.navigate(['/pages/reportes/ventas']);
    }
    if (this.tokenService.isUser_change_password()) {
      this.router.navigate(['/pages/reiniciar-contraseña']);
    }
  }

  isLoggedIn() {
    return localStorage.getItem('logged') === 'true';
  }
}
